<template lang="pug">
  BModal#the-mobile-apps-notice(
    :active.sync="modalOpen"
    has-modal-card
  )
    .modal-card
      header.modal-card-head
      section.modal-card-body.has-background-info-light
        p For the best mobile experience, download the Be Well app.
        a.app-store-buttons.apple-app-store(
          v-if="isIPhone"
          href="https://itunes.apple.com/us/app/walker-tracker/id844623241?mt=8"
        )
          img(
            alt="Download from the App Store"
            src="https://walkertracker.s3.amazonaws.com/newui/icons/app-store-badge/app-store-badge.svg"
          )
        a.app-store-buttons.google-play-store(
          v-if="isAndroid"
          href="https://play.google.com/store/apps/details?id=com.walkertracker"
        )
          img(
            alt="Download from the Google Play Store"
            src="https://walkertracker.s3.amazonaws.com/newui/icons/google-play-badge/google-play-badge.svg"
          )

      footer.modal-card-foot.custom-modal-card-foot
        WtButton(
          @click.native="modalOpen = false"
          color="grey"
        ) OK

</template>

<script>
import WtButton from "@@/WtButton/WtButton";

export default {
  name: "TheMobileAppsNotice",

  components: { WtButton },

  data() {
    return {
      isMobileBrowser: false,
      modalOpen: false
    };
  },

  computed: {
    isIPhone() {
      return /iPhone/i.test(navigator.userAgent);
    },

    isAndroid() {
      return /android/i.test(navigator.userAgent);
    }
  },

  mounted() {
    this.modalOpen = this.isIPhone || this.isAndroid;
  }
};
</script>

<style lang="sass" scoped>
#the-mobile-apps-notice
  .modal-card
    max-height: calc(100vh - 160px) // to account for the helpscout beacon
.custom-modal-card-foot
  justify-content: flex-end
.app-store-buttons
  height: 30px
  border-radius: $radius
  cursor: pointer
  margin: 1rem 1rem 0 0
  overflow: hidden
  display: flex
  justify-content: center
  align-items: center
  &:hover
    box-shadow: $box-shadow-slight
  img
    width: 100px !important
    height: 100px !important
</style>
